import CkPlugin from './CkPlugin';

export default class ButtonPlugin extends CkPlugin {
    createNode() {
        let nodeElement = document.createElement("button");
        nodeElement.innerHTML = this.name;
        nodeElement.className = 'ck ck-button ck-button_with-text ck-enabled ck-off';
        nodeElement.type = 'button';
        nodeElement.tabIndex = -1;
        return nodeElement;
    }
}